import { RoomType, User } from "@prisma/client";
import { useNavigate, useSearchParams } from "react-router";
import { useState } from "react";
import { RoomCreateOrUpdateUsersResponse } from "@api/src/types/responses";

type ButtonWriteProps = {
  user: Pick<User, "id" | "firstName" | "lastName">;
  isInTheRoom: boolean;
  numberOfUsersInTheRoom: number;
  className?: string;
};

const ButtonWrite = ({ user, isInTheRoom, numberOfUsersInTheRoom, className = "" }: ButtonWriteProps) => {
  const [searchParams] = useSearchParams();
  const [isProcessing, setIsProcessing] = useState(false);
  const [_isInTheRoom, setIsInTheRoom] = useState(isInTheRoom);
  const navigate = useNavigate();

  const qRoomId = searchParams.get("qRoomId");
  const qRoomType = searchParams.get("qRoomType");
  const isDirectMessageWithTwoUsers = qRoomType === RoomType.DIRECT && isInTheRoom && numberOfUsersInTheRoom === 2;
  const forNewDiscussion = !qRoomType || (qRoomType === RoomType.DIRECT && !qRoomId);

  if (isDirectMessageWithTwoUsers) {
    return <p className="text-sm text-gray-500 text-right m-0">Déjà dans la discussion</p>;
  }

  const handleAction = async (action: "add-user" | "remove-user") => {
    setIsProcessing(true);
    try {
      fetch(`${import.meta.env.VITE_API_URL}/room`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId: user.id,
          roomId: qRoomId,
          action,
        }),
      })
        .then((response) => response.json() as Promise<RoomCreateOrUpdateUsersResponse>)
        .then((response) => {
          if (response?.data?.roomId) {
            if (forNewDiscussion) {
              // start discussion
              console.log(
                "start discussion",
                `/?qRoomType=${RoomType.DIRECT}&qRoomId=${encodeURIComponent(response.data.roomId)}`
              );
              navigate(`/?qRoomType=${RoomType.DIRECT}&qRoomId=${encodeURIComponent(response.data.roomId)}`);
            } else {
              if (action === "add-user") {
                setIsInTheRoom(true);
              } else {
                setIsInTheRoom(false);
              }
            }
          } else if (response?.error) {
            alert(response.error);
          }
        });
      // Optionally handle success (redirect or state update)
    } catch (error) {
      console.error("Error processing action:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  if (qRoomType === RoomType.DIRECT && _isInTheRoom) {
    return (
      <button
        onClick={() => handleAction("remove-user")}
        disabled={isProcessing || isDirectMessageWithTwoUsers}
        className={["rounded-full border border-red-500 px-4 py-1", "text-red-500 bg-white hover:scale-105", className]
          .filter(Boolean)
          .join(" ")}
        type="button"
      >
        Retirer
      </button>
    );
  }

  return (
    <button
      onClick={() => handleAction("add-user")}
      disabled={isProcessing || isDirectMessageWithTwoUsers}
      className={["rounded-full border border-sky-900 px-4 py-1", "bg-sky-900 text-white hover:scale-105", className]
        .filter(Boolean)
        .join(" ")}
      type="button"
    >
      {forNewDiscussion ? "Écrire" : "Ajouter"}
    </button>
  );
};

export default ButtonWrite;
